/**
 * 视频相关
 */

module.exports = {
  xdvideo: {
    controls: true, // 控制条
    loop: false, // 循环
    autoplay: true, // 自动播放
    scrollAutoPlay: true, // 滚动到可视区域中间时播放
    poster: '', // 视频封面
    playButton: '', // 自定义播放按钮
    ld: '', // 480
    hd: '', // 720
    fhd: '', // 1080
    type: 'video/mp4', // application/x-mpegURL
    aspectRatio: '1: 1',
    pictureInPictureToggle: true, //是否开启画中画
    autoFullScreen: false, //播放时自动全屏
    muted: false, // 静音
    preload: 'none', // 预加载
    progressive: false,
    canvasAlpha: true,
    webGL: false,
  },
};
